import { Component, h, Element, Prop } from "@stencil/core"
import {
  getAppearance,
  translate,
} from "../../core/helpers/webcomponent-helpers"
import { BackgroundTheme } from "../../core/types/types"
import { IconName } from "../../core/types/icon-names"

@Component({
  tag: "sdx-tag",
  styleUrl: "tag.scss",
  shadow: true,
})
export class Tag {
  @Element() public el!: HTMLSdxTagElement

  /**
   * Text content.
   */
  @Prop() public label?: string

  /**
   * The colour variation.
   */
  @Prop() public theme: "standard" | "sales" | "new" = "standard"

  /**
   * Background theme. Use "dark" when placed on a gradient background.
   */
  @Prop() public background: BackgroundTheme = "light"

  /**
   * Which icon to display.
   */
  @Prop() public iconName?: IconName

  private getLabel(): string | undefined {
    if (this.theme === "new") {
      return translate("New", this.el.lang)
    }

    return this.label
  }

  private getComponentClassNames() {
    return {
      component: true,
      [this.theme]: true,
      [this.background]: true,
      [getAppearance(this.el)]: true,
    }
  }

  public render() {
    return (
      <div class={this.getComponentClassNames()}>
        {this.iconName && (
          <sdx-icon class="icon" size={1} iconName={this.iconName} />
        )}

        <span class="label">{this.getLabel()}</span>
      </div>
    )
  }
}
